import { JSX } from 'react'

import { IconProps } from '../../icon'

const Loading: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.7547 12.547C25.7097 11.2503 22.2744 11.2164 19.2046 12.4526C18.2954 12.8187 17.2615 12.3785 16.8954 11.4693C16.5293 10.5601 16.9695 9.5263 17.8787 9.16018C21.8219 7.57232 26.2343 7.61592 30.1453 9.28136C34.0564 10.9468 37.1454 14.0977 38.7334 18.0408C40.321 21.984 40.2777 26.3963 38.612 30.3074C37.5841 32.7215 35.9901 34.8225 33.993 36.4506H38.0633C39.0434 36.4506 39.838 37.2452 39.838 38.2253C39.838 39.2055 39.0434 40 38.0633 40H29.1899C28.2097 40 27.4152 39.2055 27.4152 38.2253V37.2906C27.4145 37.2633 27.4145 37.2361 27.4152 37.2091V29.3519C27.4152 28.3717 28.2097 27.5772 29.1899 27.5772C30.17 27.5772 30.9645 28.3717 30.9645 29.3519V34.2903C32.8883 32.9595 34.4154 31.1031 35.3464 28.9167C36.6432 25.8719 36.6771 22.4368 35.441 19.3667C34.2046 16.2967 31.7997 13.8436 28.7547 12.547ZM12.5609 13.6633C13.5411 13.6633 14.3356 14.4579 14.3356 15.438V15.4557C14.3356 16.4359 13.5411 17.2304 12.5609 17.2304C11.5808 17.2304 10.7863 16.4359 10.7863 15.4557V15.438C10.7863 14.4579 11.5808 13.6633 12.5609 13.6633ZM9.77469 20.4783C10.7548 20.4783 11.5494 21.2728 11.5494 22.253V22.2707C11.5494 23.2509 10.7548 24.0454 9.77469 24.0454C8.79456 24.0454 8 23.2509 8 22.2707V22.253C8 21.2728 8.79456 20.4783 9.77469 20.4783ZM10.7863 27.7547C11.7664 27.7547 12.5609 28.5492 12.5609 29.5293V29.5471C12.5609 30.5273 11.7664 31.3218 10.7863 31.3218C9.80613 31.3218 9.01157 30.5273 9.01157 29.5471V29.5293C9.01157 28.5492 9.80613 27.7547 10.7863 27.7547ZM15.2762 33.5579C16.2564 33.5579 17.0509 34.3524 17.0509 35.3326V35.3503C17.0509 36.3305 16.2564 37.125 15.2762 37.125C14.2961 37.125 13.5015 36.3305 13.5015 35.3503V35.3326C13.5015 34.3524 14.2961 33.5579 15.2762 33.5579ZM22.0911 36.3438C23.0713 36.3438 23.8658 37.1383 23.8658 38.1185V38.1362C23.8658 39.1164 23.0713 39.9109 22.0911 39.9109C21.1109 39.9109 20.3164 39.1164 20.3164 38.1362V38.1185C20.3164 37.1383 21.1109 36.3438 22.0911 36.3438Z'
      fill='black'
    />
  </svg>
)

export default Loading
